import { yupResolver } from "@hookform/resolvers/yup";
import {
    Box,
    Stack,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";

import { DocumentInfo } from "../../../../../../../../models/documents";
import HeaderMetadata from "./HeaderMetadata";
import HeaderTitle from "./HeaderTitle";

interface IDocumentHeaderProps {
    documentInfo: DocumentInfo & Partial<{ date: string }>;
    handleUpdateInfo: (info: DocumentInfo) => void | Promise<void>;
}

const metadataSchema = yup.object().shape({
    document_title: yup.string().required("Título é obrigatório"),
    enterprise: yup.string().required("Empresa é obrigatória"),
    project: yup.string().required("Projeto é obrigatório"),
});

type FormData = {
    document_title: string;
    enterprise: string;
    project: string;
};

export default function DocumentHeader({
    documentInfo,
    handleUpdateInfo,
}: IDocumentHeaderProps) {
    const [dialogOpen, setDialogOpen] = useState(false);

    const { control, handleSubmit, setValue, reset } = useForm<FormData>({
        defaultValues: {
            document_title: documentInfo.document_title,
            enterprise: documentInfo.enterprise,
            project: documentInfo.project,
        },
        resolver: yupResolver(metadataSchema),
    });

    // Sempre que o documentInfo mudar, atualiza o form (também para cancelar edição)
    useEffect(() => {
        reset({
            document_title: documentInfo.document_title,
            enterprise: documentInfo.enterprise,
            project: documentInfo.project,
        });
    }, [documentInfo, reset]);

    const onOpenDialog = () => setDialogOpen(true);

    const onCloseDialog = () => {
        reset({
            document_title: documentInfo.document_title,
            enterprise: documentInfo.enterprise,
            project: documentInfo.project,
        });
        setDialogOpen(false);
    };

    const onSubmit = (data: FormData) => {
        handleUpdateInfo(data);
        setDialogOpen(false);
    };

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    justifyContent: "space-between",
                    alignItems: { xs: "stretch", md: "center" },
                    gap: 2,
                    mb: 3,
                }}
            >
                <Box sx={{ flexGrow: 1 }}>
                    <Stack
                        flexDirection="row"
                        justifyContent="space-between"
                        alignItems="center"
                        gap="16px"
                    >
                        <HeaderTitle
                            title={documentInfo.document_title}
                            isEditing={false} // Não está editando fora do diálogo
                            control={control}
                        />
                        {/* Botão para abrir diálogo */}
                        <Button variant="outlined" onClick={onOpenDialog}>
                            Editar Cabeçalho
                        </Button>
                    </Stack>
                    <HeaderMetadata
                        company={documentInfo.enterprise}
                        control={control}
                        project={documentInfo.project}
                        date={documentInfo.date!}
                        isEditing={false}
                    />
                </Box>
            </Box>

            {/* Diálogo de edição */}
            <Dialog
                open={dialogOpen}
                onClose={onCloseDialog}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>Editar Informações do Documento</DialogTitle>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent>
                        <Box mb="20px">
                            <HeaderTitle
                                isEditing
                                control={control}
                                title={documentInfo.document_title}
                            />
                            <HeaderMetadata
                                company={documentInfo.enterprise}
                                control={control}
                                project={documentInfo.project}
                                date={documentInfo.date!}
                                isEditing
                            />
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onCloseDialog}>Cancelar</Button>
                        <Button type="submit" variant="contained">
                            Confirmar
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}
